<template>
  <div class="cart-item panel p-2 p-sm-3">
    <div class="row no-gutters">
      <div class="col-8 mb-2">
        <icon :icon="icon" class="cart-item-icon svg-icon float-left"/>
        <div class="text-uppercase font-weight-bold text-primary float-left font-size-sm pl-2 pt-2">
          {{ subtitle }}
        </div>
      </div>
      <div class="col-4 mb-2 text-right">
        <div class="cart-item-menu">
          <ContextMenu
              :id="`cart-item-menu-${index}`"
              :items="menu"
              align="right"
          />
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <h4 class="mb-2">
          <a class="text-dark" :href="detailsUrl">{{ title }}</a>
        </h4>
        <h3 v-if="!isEvent" class="mb-2">{{ item.cost | cost }}</h3>
        <div v-else class="cart-item-details">
          <span class="dt mr-2">Event ID:</span>
          <span class="dd">{{ item.enrollable.id }}</span>
        </div>
        <div v-if="(isCourse || isLearningPath) && !!item.nate_credit_available" class="cart-item-details">
          <span class="dt mr-2">NATE Credit?:</span>
          <span class="dd">
            <a href="#"
               @click.prevent="$emit('edit-nate', item)"
               title="Add NATE Credit">
              <template v-if="!!item.nate_id">
                <span class="text-dark"><strong>Yes</strong> (NATE ID: {{ item.nate_id }})</span>
              </template>
              <template v-else>
                <span class="text-primary"><strong>Click to Add</strong></span>
              </template>
            </a>
          </span>
        </div>

        <div v-if="isEvent && item.includedCourses.length" class="mt-4">
          <h5 class="font-weight-bold">Included Courses</h5>
          <ul v-for="course in item.includedCourses" class="mt-1 mb-0">
            <li style="font-size: 12px;">
              {{ course.name }}
              <span v-if="course.is_nate" class="d-block">
                <a href="#"
                   @click.prevent="$emit('edit-nate', item, 'classroom')"
                   title="Add NATE Credit">
                  <template v-if="!!item.nate_id">
                     <span class="text-dark mr-1">NATE Credit?</span>
                    <span class="text-dark"><strong>Yes</strong> (NATE ID: {{ item.nate_id }})</span>
                  </template>
                  <template v-else>
                    <span class="text-primary">NATE Credit?</span>
                    <span class="text-primary"><strong>Click to Add</strong></span>
                  </template>
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-6 pl-sm-3 cart-item-details">
        <div class="row">
          <div class="dt col-3">Student:</div>
          <div class="dd col-9">
            <strong>{{ item.user.name }}</strong>
            <div v-if="item.user.hvac_id">(ID: {{ item.user.hvac_id }})</div>
          </div>
        </div>
        <div class="row">
          <div class="dt col-3">Company:</div>
          <div class="dd col-9">
            <strong>{{ item.user.company.name }}</strong>
            <div v-if="item.user.company.hvac_id">
              (ID: {{ item.user.company.hvac_id }})
            </div>
          </div>
        </div>
        <div class="row">
          <div class="dt col-3">Brand:</div>
          <div class="dd col-9">
            <a v-if="canChangeBrands"
               href="#"
               @click.prevent="$emit('change-brand', item)"
               title="Change Brand">

              <strong>{{ item.brand.name }}</strong>
            </a>
            <strong v-else>{{ item.brand.name }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {type: Object, required: true},
    index: {type: Number, required: true},
  },
  computed: {
    isCourse() {
      return !!this.item.item_type && this.item.item_type === "course";
    },
    isEvent() {
      return !!this.item.item_type && this.item.item_type === "event";
    },
    isLearningPath() {
      return !!this.item.item_type && this.item.item_type === "learning_path";
    },
    icon() {
      if (this.isLearningPath) {
        return "grad-cap";
      } else if (this.isEvent) {
        return "calendar";
      } else {
        return "courses";
      }
    },
    subtitle() {
      if (this.isLearningPath) {
        return "Learning Path";
      } else if (this.isEvent) {
        return `${this.item.enrollable.type_label} Event`;
      } else {
        return "Online Course";
      }
    },
    title() {
      if (this.isLearningPath) {
        return this.item.learning_path.name;
      } else if (this.isEvent) {
        return `${this.item.enrollable.name} - ${this.$moment(
            this.item.enrollable.start_date
        ).format("MM/DD/YY")}`;
      } else {
        return this.item.enrollable.name;
      }
    },
    detailsUrl() {
      if (this.isLearningPath) {
        return this.route("learning-paths.show", {
          learning_path: this.item.learning_path.id,
        });
      } else if (this.isEvent) {
        return this.route("catalog.course", {
          course: this.item.enrollable.course_id,
        });
      } else {
        return this.route("catalog.course", {
          course: this.item.enrollable.id,
        });
      }
    },
    enrollUrl() {
      if (this.isLearningPath) {
        return this.route("enroll.online.learning-path.others", {
          learning_path: this.item.learning_path.id,
        });
      } else if (this.isEvent) {
        return this.route("enroll.classroom.event.others", {
          event: this.item.enrollable.id,
        });
      } else {
        return this.route("enroll.online.course.others", {
          course: this.item.enrollable.id,
        });
      }
    },
    canChangeBrands() {
      return (
          !!this.item.enrollable_brands && this.item.enrollable_brands.length > 1
      );
    },
    menu() {
      let menu = [];
      if (this.item.can_remove) {
        menu.push({
          label: "Remove From Cart",
          action: () => {
            this.$emit("remove", this.item);
          },
        });
      }
      if (this.canChangeBrands) {
        menu.push({
          label: "Change Brand",
          action: () => {
            this.$emit("change-brand", this.item);
          },
        });
      }
      if (!!this.item.nate_credit_available) {
        menu.push({
          label: "NATE Credit",
          action: () => {
            this.$emit("edit-nate", this.item);
          },
        });
      }
      menu.push({
        label: "Enroll Others",
        action: () => {
          this.goToUrl(this.enrollUrl);
        },
      });
      return menu;
    },
  },
};
</script>